export class AppStatus {
	down: boolean;
	timestamp: number;

	constructor(down: boolean, timestamp: number) {
		this.down = down;
		this.timestamp = timestamp;
	}
}
